<template>
    <div id="app">
        <home />
        <container />
        <result />
    </div>
</template>

<script>
    import { setShare } from './libs/libs.js'
    import Home from './components/Home'
    import Container from './components/Container'
    import Result from './components/Result'
    export default {
        name: 'App',
        created () {
            setShare( '词汇量知根知底，遇考试百战百捷。你敢测测吗？',true)
        },
        components: {
            Home,
            Container,
            Result
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue